export function rmSchema(url: string) {
  if (url) {
    url = url.replace(/http(s?):/, '')
  }
  return url
}
